var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7831 9.99997L15.3887 5.39441C15.4797 5.28813 15.5272 5.15142 15.5218 5.0116C15.5164 4.87178 15.4585 4.73915 15.3595 4.64021C15.2606 4.54127 15.128 4.48331 14.9881 4.47791C14.8483 4.4725 14.7116 4.52006 14.6053 4.61108L9.99977 9.21663L5.39421 4.60552C5.2896 4.50091 5.14771 4.44214 4.99977 4.44214C4.85182 4.44214 4.70994 4.50091 4.60532 4.60552C4.50071 4.71014 4.44194 4.85202 4.44194 4.99997C4.44194 5.14791 4.50071 5.2898 4.60532 5.39441L9.21643 9.99997L4.60532 14.6055C4.54717 14.6553 4.49993 14.7166 4.46659 14.7855C4.43324 14.8545 4.4145 14.9295 4.41155 15.006C4.40859 15.0826 4.42148 15.1589 4.44941 15.2301C4.47734 15.3014 4.51971 15.3662 4.57385 15.4203C4.62799 15.4745 4.69274 15.5168 4.76403 15.5448C4.83532 15.5727 4.91162 15.5856 4.98813 15.5826C5.06464 15.5797 5.13972 15.5609 5.20864 15.5276C5.27757 15.4942 5.33885 15.447 5.38866 15.3889L9.99977 10.7833L14.6053 15.3889C14.7116 15.4799 14.8483 15.5274 14.9881 15.522C15.128 15.5166 15.2606 15.4587 15.3595 15.3597C15.4585 15.2608 15.5164 15.1282 15.5218 14.9883C15.5272 14.8485 15.4797 14.7118 15.3887 14.6055L10.7831 9.99997Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.51eed63b1315229e5071cee45eabf250.svg";
export { ForwardRef as ReactComponent };